/**
 *
 * @module adEngineManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class AdEngineManagerConfiguration
 *
 */
export default class AdEngineManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/adEngineManagerConfiguration.js